import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useRouteMatch, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import './findLawyer.scss';
import ListSearcher from '../../components/Searcher/ListSearch';
import ClientMainTitle from '../../components/MainTiles/ClientMainTitle';
import NormalCardwyer from '../../components/CardLawyer/NormalCard';
import Banner from '../../components/Banners/Banner';
import ListLawyers from './ListLaywers';
import { connect } from 'react-redux'
import { changeTab } from '../../store/actions/LaywerUserAction';

//import { storage, firestore} from '../../../configs/environments/firebase/firebaseApp';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingBottom: 24,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  banner: {
    '@media (max-width: 959px)': {
      display: 'none',
    },
  },
}));

const FindLawyer = (props) => {

  const history = useHistory();
  const classes = useStyles();

  const [value, setValue] = useState(
    props.filterTab && props.filterTab === 'lawyer' ?
    0 :
    props.filterTab && props.filterTab === 'lawFirm' ?
    1 : 0
  );
  const [specialtySelected, setSpecialtySelected] = useState(
    props.match.params.specialty === undefined
      ? ''
      : props.match.params.specialty
  );
  const [stateSelected, setStateSelected] = useState(
    props.match.params.state === undefined ? '' : props.match.params.state
  );

  let { specialty, state, subSpeciality } = useParams();
  // let params = useParams();
  // console.log('params', params);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const searchFirms = useRouteMatch('/busqueda/Despachos');

  const validationRoute = () => {
    if (
      window.previousLawFirmLocation &&
      window.previousLawFirmLocation.includes('despacho')
    ) {
      const boolValue = window.previousLawFirmLocation.includes('despacho');
      return boolValue;
    }
  };
  

  useEffect(() => {
    const validationValue = validationRoute();
    setValue(value === 1 || searchFirms || validationValue ? 1 : 0);
    setSpecialtySelected(subSpeciality ? subSpeciality : specialty);
    setStateSelected(state);
    delete window.previousLawFirmLocation;
    props.changeTab(
      props.lawyerData.data ?
      (props.lawyerData.data[0] &&
      props.lawyerData.data[0].role === 'lawyer' ?
        0 :
      props.lawyerData.data[0] &&
      props.lawyerData.data[0].role === 'lawFirm' ?
        1 : 1
      ) :
      1
    )
  }, [props, searchFirms, specialty, state, value]);

  const handleSetStateBtn = (inputState, specialityState, subSpecialityState) => {
    setSpecialtySelected(subSpecialityState ? subSpecialityState : specialityState);
    setStateSelected(inputState);
    if (specialityState && subSpecialityState && inputState) {
      history.replace(`/busqueda/especialidad/${specialityState}/${subSpecialityState}/${inputState}`);
    } else if (specialityState && inputState) {
      history.replace(`/busqueda/estado/${inputState}/${specialityState}`);
    } else if(specialityState && subSpecialityState){
      history.replace(`/busqueda/especialidad/${specialityState}/${subSpecialityState}`);
    } else if(specialityState){
      history.replace(`/busqueda/especialidad/${specialityState}`);
    } else if(inputState){
      history.replace(`/busqueda/estado/${inputState}`);
    } else {
      history.replace('/busqueda')
    }
  };

  function foo(callback, specialtySelected, stateSelected) {
    callback(specialtySelected, stateSelected);
  }

  return (
    <div style={{ maxWidth: 1360, margin: 'auto' }}>
      <section className="findLawyer">
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className="cardFind">
                <ClientMainTitle
                  title="Encuentra un Abogado"
                  subtitle="Elige, dentro del listado de abogados, el que más se ajuste a tus necesidades."
                />
                <ListSearcher
                  filterValues={{ specialtySelected, stateSelected }}
                  handleBtn={handleSetStateBtn}
                  role={value}
                />
              </div>
            </Grid>

            <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                  >
                    <LinkTab
                      label="Abogados"
                      href="/abogados"
                      {...a11yProps(0)}
                    />
                    <LinkTab
                      label="Despachos"
                      href="/despachos"
                      {...a11yProps(0)}
                    />
                  </Tabs>
                </Paper>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={9}>
              <TabPanel value={value} index={0}>
                <ListLawyers
                  role="lawyer"
                  specialty={
                    specialtySelected == undefined ? '' : specialtySelected
                  }
                  stateSite={stateSelected == undefined ? '' : stateSelected}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <ListLawyers
                  role="lawFirm"
                  specialty={
                    specialtySelected == undefined ? '' : specialtySelected
                  }
                  stateSite={stateSelected == undefined ? '' : stateSelected}
                />
              </TabPanel>
            </Grid>
            <Grid item xs={12} md={3} className={classes.banner}>
              <Banner forLawyer />
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = state => ({
  lawyerData: state.paginationReducer.laywerData,
  filterTab: state.paginationReducer.filterTab
})

const mapDispatchToProps = dispatch => ({
  changeTab: (index) => dispatch(changeTab(index))
})

export default connect(mapStateToProps, mapDispatchToProps)(FindLawyer);

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      key={index}
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
